import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Client } from "../../api-client";
import { TABLE_ROWS_COUNT } from "../../../shared/constants";
import { API_CREATE_DEPARTMENT, API_DELETE_DEPARTMENT, API_GET_DEPARTMENT_LIST, API_UPDATE_DEPARTMENT } from "../../../shared/routes/private.routes";

const config = {
  name: "department",
};

export const getDepartmentList: any = createAsyncThunk(
  `${config.name}/getDepartmentList`,
  async ({params, body}: any) => {
    return Client.post(API_GET_DEPARTMENT_LIST, body, {params});
  }
);

export const createDepartment: any = createAsyncThunk(
  `${config.name}/create-departments`,
  async (body: any) => {
    return Client.post(API_CREATE_DEPARTMENT, body);
  }
);

export const deleteDepartment: any = createAsyncThunk(
  `${config.name}/delete-department`,
  async (departmentId: string) => {
    return Client.delete(API_DELETE_DEPARTMENT+`${departmentId}`);
  }
);

export const updateDepartmentById: any = createAsyncThunk(
  `${config.name}/update-department`,
  async ({ departmentId, body }: { departmentId: string, body: any }) => {
    const url = API_UPDATE_DEPARTMENT + `${departmentId}`;
    return Client.put(url, body);
  }
);

export const departmentReducer = createSlice({
  name: config.name,
  initialState: {
    loadingDepartment: false as any,
    departmentList: [] as any, 
    filters: {} as any, 
    pagination: {page: 0, limit: TABLE_ROWS_COUNT, total: 0}
  },
  reducers: {
    resetDepartment: (state) => {
      state.loadingDepartment = false;
      state.departmentList = [];
      state.filters = {};
      state.pagination = {page: 0, limit: TABLE_ROWS_COUNT, total: 0};
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getDepartmentList.pending, (state) => {
        state.loadingDepartment = true;
        state.departmentList = [] as any;
      })
      .addCase(getDepartmentList.fulfilled, (state, action) => {
        state.loadingDepartment = false;
        state.departmentList = action?.payload?.data?.data as any;
        state.pagination = {page: action?.payload?.data?.page, limit: action?.payload?.data?.limit, total: action?.payload?.data?.total}
      })
      .addCase(getDepartmentList.rejected, (state) => {
        state.loadingDepartment = false;
        state.departmentList = [] as any;
      })
  },
});

export const { resetDepartment } = departmentReducer.actions;
export default departmentReducer.reducer;
